module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('label', {
    staticClass: "col-4 col-form-label"
  }, [_vm._v("\n    Цвет\n    "), _c('span', {
    staticClass: "badge",
    style: ({
      'background-color': _vm.color.hex
    })
  }, [_vm._v("\n      " + _vm._s(_vm.color.hex) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('color-picker', {
    on: {
      "input": function($event) {
        _vm.$emit('input', _vm.color.hex)
      }
    },
    model: {
      value: (_vm.color),
      callback: function($$v) {
        _vm.color = $$v
      },
      expression: "color"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-2c7e89d2"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcColorPicker.vue
// module id = 1015
// module chunks = 1